<div class="modal-dialog modal-dialog-centered" style="padding: 0">
  <div class="modal-content">
    <div class="modal-header" style="padding: 20px 30px 16px 30px; border-bottom: 1px solid #e9ecef">
      <h5 class="modal-title" style="font-weight: 700; margin: 0">
        {{ 'record.download.filtersModal.title' | translate }}
      </h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()"
        style="background: transparent; border: none; font-size: 1.4rem; line-height: 1; padding: 0"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body" style="padding: 24px 30px">
      <div *ngIf="parsedFilters.length === 0" style="color: #6c757d; font-size: 14px">
        {{ 'record.download.filtersModal.noFilters' | translate }}
      </div>
      <table *ngIf="parsedFilters.length > 0" style="width: 100%; font-size: 14px; border-collapse: collapse">
        <tbody>
          <tr *ngFor="let f of parsedFilters" style="border-bottom: 1px solid #f0f0f0">
            <td style="padding: 10px 16px 10px 0; font-weight: 600; color: #495057; white-space: nowrap; width: 38%; vertical-align: top">
              {{ f.labelKey | translate }}
            </td>
            <td style="padding: 8px 0; vertical-align: top">
              <div style="display: flex; flex-wrap: wrap; gap: 6px">
                <span
                  *ngFor="let v of f.values"
                  style="
                    display: inline-block;
                    background: #e9ecef;
                    color: #343a40;
                    border-radius: 4px;
                    padding: 3px 10px;
                    font-size: 13px;
                    line-height: 1.4;
                  "
                >{{ v }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer" style="padding: 16px 30px 20px 30px; border-top: 1px solid #e9ecef">
      <button
        class="btn btn-primary"
        style="padding: 8px 24px; font-weight: 600"
        (click)="activeModal.dismiss()"
      >
        {{ 'record.download.filtersModal.close' | translate }}
      </button>
    </div>
  </div>
</div>
